var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServerRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_65086",
    "data-name": "Group 65086",
    transform: "translate(-1437 -179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65078",
    "data-name": "Group 65078",
    transform: "translate(0 14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65077",
    "data-name": "Group 65077",
    transform: "translate(9 -17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Youtube",
    transform: "translate(1427.997 181.914)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(0.003 0.086)",
    fill: "#f4f4f4",
    opacity: 0.996
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Check_Mark",
    d: "M15.151,30.3A15.151,15.151,0,1,1,30.3,15.151,15.169,15.169,0,0,1,15.151,30.3Zm0-28.409A13.257,13.257,0,1,0,28.409,15.151,13.272,13.272,0,0,0,15.151,1.894ZM12.98,20.556l9.47-9.47a.947.947,0,1,0-1.339-1.339l-8.8,8.8L9.192,15.429a.947.947,0,0,0-1.339,1.339l3.788,3.788a.946.946,0,0,0,1.339,0Z",
    transform: "translate(1446.849 188.849)",
    fill: "#35b729"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerRequest);
export default __webpack_public_path__ + "static/media/server-request.3fae8fb6.svg";
export { ForwardRef as ReactComponent };